import classNames from 'classnames';
import React, {memo} from 'react';
import style from './style.module.scss';
import {PRODUCT_CARD_VARIANT, PRODUCT_LIST_VIEW, PRODUCT_TYPE} from 'modules/products/constants';
import {TProductCardVariant, TProductListView} from 'modules/products/types';
import {ProductOfferDetail} from 'models';
import Icon from 'components/Icon';

export const NO_IMAGE_SIZE: Record<'BIG' | 'DEFAULT' | 'SMALL' | 'STRETCHED', TNoImageSize> = {
    BIG: 'big',
    DEFAULT: 'default',
    SMALL: 'small',
    STRETCHED: 'stretched',
};

type TNoImageSize = 'big' | 'small' | 'stretched' | 'default';

interface IProps {
    className?: string;
    type?: ProductOfferDetail['type'];
    size?: TNoImageSize;
    listView?: TProductListView;
    variant?: TProductCardVariant;
}

export const NoImage = memo<IProps>(function NoImage({
    className,
    size = NO_IMAGE_SIZE.BIG,
    type = PRODUCT_TYPE.simple,
    listView = PRODUCT_LIST_VIEW.tile,
    variant = PRODUCT_CARD_VARIANT.auto,
}) {
    return (
        <div
            className={classNames(style.noImage, className, {
                [style[type]]: Boolean(type),
                [style[size]]: Boolean(size),
                [style[listView]]: Boolean(listView),
                [style[variant]]: Boolean(variant),
            })}
            data-skeleton-item={true}
        >
            <Icon icon={'no-image'} />
        </div>
    );
});
